import React, { useContext, useState } from 'react'
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import { Box, Paper, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Button } from '@mui/material';
import { AuthorityMasterType, useAuthorityMaster } from '../DataFetch/useAuthorityMaster';
import { AuthorityMasterEdit } from './AuthorityMasterEdit';
import { SessionContext } from '../ManagementRoot';

/**
 * 権限マスタ画面
 * 権限マスタの参照、編集
 */
export function AuthorityMaster() {

    const {authorityMaster, mutate} = useAuthorityMaster();

    //編集フラグ、trueになると編集画面表示
    const [editing, setEditing] = useState<boolean>(false);

    //編集対象データを格納
    const [editData, setEditData] = useState<AuthorityMasterType | undefined>(undefined);

    //セッション確認関数
    const ConfirmSession = useContext(SessionContext);

    //編集画面を開く
    async function OpenEditor(data:AuthorityMasterType | undefined) {
        
        if(!await ConfirmSession()) {
            return;
        }

        setEditData(data);
        setEditing(true);
    }

    //編集完了関数
    function CompleteEdit() {
        setEditing(false);
        mutate();   //権限マスタを再取得
    }

    //権限リスト要素
    function AuthorityList() {
        return(
            <>
                <TableContainer sx={{maxHeight:800}}>
                    <Table stickyHeader>
                        <TableHead>
                            <TableRow>
                                <TableCell>権限ID</TableCell>
                                <TableCell>権限名</TableCell>
                                <TableCell>選択可能数</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {authorityMaster?.map((item:AuthorityMasterType, index:number) => (
                                <TableRow key={index} hover>
                                    <TableCell>{item.authority_id}</TableCell>
                                    <TableCell>{item.authority_name}</TableCell>
                                    <TableCell>{item.select_num}</TableCell>
                                    <TableCell>
                                        <Button variant="contained" onClick={() => OpenEditor(item)}>編集</Button>
                                    </TableCell>
                                </TableRow>
                            ))} 
                        </TableBody>
                    </Table>
                </TableContainer>
            </>
        );
    }

    return(
        <>
            <Typography
                variant="h6"
            >
                ユーザーマスタ
            </Typography>
            <Grid2 xs={12}>
                <Paper sx={{overflow:"hidden", whiteSpace:"nowrap"}}>
                    <Box m={2} p={1}>
                        {/* フラグによって表示画面を切替 */}
                        {editing ? <AuthorityMasterEdit editData={editData} CompleteEdit={CompleteEdit} setEditing={setEditing} /> : <AuthorityList/>}
                    </Box>
                </Paper>
            </Grid2>
        </>
    );
}